'use strict';

/*global initialize*/
function OpeningHours($container) {
    this.$container = $container;

    this.init();
}

OpeningHours.prototype = $.extend({}, {
    construtor: 'OpeningHours',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        _this.$container.off('click', '.add-opening-hours-interval');
        _this.$container.on('click', '.add-opening-hours-interval', function addOpeningHoursIntervalClickClb() {

            _this.addOpeningHoursInterval($(this).closest('.opening-hours-day-wrapper'));
            return false;
        });

        _this.$container.off('click', '.copy-opening-hours-interval');
        _this.$container.on('click', '.copy-opening-hours-interval', function copyOpeningHoursIntervalClickClb() {

            _this.copyOpeningHoursInterval($(this).closest('.opening-hours-day-wrapper'));
            return false;
        });        

        _this.$container.off('change ifChanged', '.opening-hours-closed');
        _this.$container.on('change ifChanged', '.opening-hours-closed', function closedChangeClb() {

            _this.changeClosed($(this).closest('.opening-hours-day-wrapper'), $(this).is(':checked'));
        });

        return _this;
    },

    //**************************************************************************

    addOpeningHoursInterval: function addOpeningHoursIntervalClick($wrapper) {
        var _this = this;

        var $original = $wrapper.find('.opening-hours-interval:last');
        var $clone = $original.clone();

        $clone.insertAfter($original);
        $clone.find('input:visible').val('');

        if ('initialize' in window) {
            initialize($clone);
        }

        return _this;
    },

    copyOpeningHoursInterval: function copyOpeningHoursInterval($wrapper) {
        var _this = this;

        $wrapper.nextAll().each(function () {
            var $targetWrapper = $(this);

            if (!$targetWrapper.find('.opening-hours-closed').is(':checked')) {
                var $original = $wrapper.find('.opening-hours-intervals-wrapper');
                var $clone = $original.clone();

                $targetWrapper.find('.opening-hours-intervals-wrapper').replaceWith($clone);

                $targetWrapper.find('.opening-hours-intervals-wrapper').find('input').each(function () {
                    var name = $(this).attr('name');

                    name = name.replace($wrapper.data('prefix'), $targetWrapper.data('prefix'));

                    $(this).attr('name', name);
                });

                if ('initialize' in window) {
                    initialize($targetWrapper.find('.opening-hours-intervals-wrapper'));
                }
            }
        });

        return _this;
    },

    changeClosed: function changeClosed($wrapper, isClosed) {
        var _this = this;

        if (isClosed) {
            $wrapper.find('.opening-hours-intervals-wrapper').hide();
            $wrapper.find('.btn').hide();
            $wrapper.find('.opening-hours-closed-text').show();
        } else {
            $wrapper.find('.opening-hours-intervals-wrapper').show();
            $wrapper.find('.btn').show();
            $wrapper.find('.opening-hours-closed-text').hide();
        }

        return _this;
    },

    reset: function reset() {
        var _this = this;

        _this.$container.find('.opening-hours-day-wrapper').each(function () {
            $(this).find('.opening-hours-interval:not(:first)').remove();
            $(this).find(':text').val('');
            $(this).find(':checkbox').removeAttr('checked');
            $(this).find('.opening-hours-intervals-wrapper').show();
            $(this).find('.opening-hours-closed-text').hide();
        });

        return _this;
    },

    //**************************************************************************

    init: function init() {
        var _this = this;

        _this.registerCallbacks();

        return _this;
    }
});
